import React, { useEffect, useMemo, useState } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import DataTable from "react-data-table-component";

function formatStatus(status) {
  if (status === 1) return "Confirmado";
  if (status === 2) return "Cancelado";
  return "Pendente";
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("pt-BR");
}

function formatMoney(value) {
  if (value === undefined || value === null || value === "") return "-";
  const n = Number(value);
  if (Number.isNaN(n)) return "-";
  return n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function Show_Pedido({ match, history }) {
  const [pedido, setPedido] = useState(null);
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(false);

  const empresaid = localStorage.getItem("sgiempresaid");
  const isMaster = localStorage.getItem("sgimaster");

  const pedidoId = match?.params?.id;

  async function loadPedido() {
    const response = await api.get("/treinamentos/pedido/" + pedidoId, {
      headers: { "x-tenantid": empresaid, isMaster },
    });
    const data = await response.data;
    const item = Array.isArray(data) ? data[0] : data;
    setPedido(item || null);

    // Buscar detalhes dos produtos (nome, etc.)
    if (item && Array.isArray(item.idproduto) && item.idproduto.length > 0) {
      const body = item.idproduto.map((id) => ({ id }));
      try {
        const respProdutos = await api.post("/treinamentos/produto/idlist", body, {
          headers: { "x-tenantid": empresaid, isMaster },
        });
        const lista = await respProdutos.data;
        setProdutos(Array.isArray(lista) ? lista : []);
      } catch (e) {
        // em caso de erro, mantém apenas os ids
        setProdutos([]);
      }
    } else {
      setProdutos([]);
    }

    setLoading(false);
  }

  const columnsProdutos = useMemo(
    () => [
      {
        name: "Produto",
        selector: (row) => row.titulo,
        wrap: true,
      },
      {
        name: "ID",
        selector: (row) => String(row._id),
        wrap: true,
      },
    ],
    []
  );

  useEffect(() => {
    setLoading(true);
    loadPedido();

    setTimeout(() => {
      if (document.getElementById("menu_pedido")) {
        document.getElementById("menu_pedido").className = "active";
      }
    }, 50);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pedidoId]);

  return (
    <>
      <Header />
      <SideMenu />

      <div>
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Pedido<small> - Somente visualização</small>
            </h1>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-xs-12">
                <div className="box">
                  {loading && (
                    <div style={{ alignItems: "center", textAlign: "center" }}>
                      <img src={carregando} width="80" alt="" />
                    </div>
                  )}

                  <div className="box-body">
                    <div className="col-md-12 nopadding" style={{ marginBottom: "10px" }}>
                      <button className="btn btn-default" onClick={() => history.push("/pedidos")}>
                        <i className="fa fa-arrow-left" style={{ marginRight: "5px" }} />
                        Voltar
                      </button>
                    </div>

                    {!pedido && !loading && (
                      <div className="col-md-12">
                        <p>Nenhum pedido encontrado.</p>
                      </div>
                    )}

                    {pedido && (
                      <>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <strong>Transação</strong>
                              <div>{pedido._id}</div>
                            </div>
                            <div className="col-md-4">
                              <strong>Status</strong>
                              <div>{formatStatus(pedido.status)}</div>
                            </div>
                            <div className="col-md-4">
                              <strong>Total (R$)</strong>
                              <div>{formatMoney(pedido.total)}</div>
                            </div>
                          </div>

                          <hr />

                          <div className="row">
                            <div className="col-md-4">
                              <strong>E-mail</strong>
                              <div>{pedido.useremail || "-"}</div>
                            </div>
                            <div className="col-md-4">
                              <strong>Nome</strong>
                              <div>{pedido.nome || "-"}</div>
                            </div>
                            <div className="col-md-4">
                              <strong>Telefone</strong>
                              <div>{pedido.telefone || "-"}</div>
                            </div>
                          </div>

                          <hr />

                          <div className="row">
                            <div className="col-md-6">
                              <strong>Criado em</strong>
                              <div>{formatDate(pedido.createdAt)}</div>
                            </div>
                            <div className="col-md-6">
                              <strong>Atualizado em</strong>
                              <div>{formatDate(pedido.updatedAt)}</div>
                            </div>
                          </div>

                          <hr />

                          <div className="row">
                            <div className="col-md-12">
                              <strong>Produtos</strong>
                              <div style={{ marginTop: "10px" }}>
                                <DataTable
                                  columns={columnsProdutos}
                                  data={produtos}
                                  pointerOnHover
                                  highlightOnHover
                                  noDataComponent={""}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
}
